import { render, staticRenderFns } from "./Derivatives.vue?vue&type=template&id=da072500&scoped=true"
import script from "./Derivatives.vue?vue&type=script&lang=js"
export * from "./Derivatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da072500",
  null
  
)

export default component.exports